<template>

  <t-page>

    <div class="col-12">

      <b-tabs content-class="mt-3" pills card align="center" lazy>
        <b-tab title="Produção" title-item-class="tabs_dashboard" active>

          <div class="col-12">

            <div class="row">

              <div class="col-4 col-xl-2">

                <div
                    class="card-shadow-primary border-info mb-3 widget-chart widget-chart2 text-left card btn-outline-2x">
                  <div class="widget-chat-wrapper-outer">
                    <div class="widget-chart-content"><h6 class="widget-subheading">Aguardando</h6>
                      <div class="widget-chart-flex">
                        <div class="widget-numbers mb-0 w-100">
                          <div class="widget-chart-flex">
                            <div class="fsize-4 ml-auto mr-auto">
                              <small class="opacity-5"><i class="lnr-hand"></i></small>
                              03
                            </div>
                            <!--                            <div class="ml-auto">
                                                          <div class="widget-title ml-auto font-size-lg font-weight-normal text-muted"><span
                                                              class="text-success pl-2">+14%</span></div>
                                                        </div>-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-4 col-xl-2">

                <div
                    class="card-shadow-primary border-info mb-3 widget-chart widget-chart2 text-left card btn-outline-2x">
                  <div class="widget-chat-wrapper-outer">
                    <div class="widget-chart-content"><h6 class="widget-subheading">Matéria-Prima</h6>
                      <div class="widget-chart-flex">
                        <div class="widget-numbers mb-0 w-100">
                          <div class="widget-chart-flex">
                            <div class="fsize-4 ml-auto mr-auto">
                              <small class="opacity-5"><i class="lnr-leaf"></i></small>
                              25
                            </div>
                            <!--                            <div class="ml-auto">
                                                          <div class="widget-title ml-auto font-size-lg font-weight-normal text-muted"><span
                                                              class="text-success pl-2">+7%</span></div>
                                                        </div>-->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-4 col-xl-2">

                <div
                    class="card-shadow-primary border-warning mb-3 widget-chart widget-chart2 text-left card btn-outline-2x">
                  <div class="widget-chat-wrapper-outer">
                    <div class="widget-chart-content"><h6 class="widget-subheading">Ferramentaria</h6>
                      <div class="widget-chart-flex">
                        <div class="widget-numbers mb-0 w-100">
                          <div class="widget-chart-flex">
                            <div class="fsize-4 text-warning ml-auto mr-auto">
                              <small class="opacity-5"><i class="lnr-cog"></i></small>
                              07
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-4 col-xl-2">

                <div
                    class="card-shadow-primary border-danger mb-3 widget-chart widget-chart2 text-left card btn-outline-2x">
                  <div class="widget-chat-wrapper-outer">
                    <div class="widget-chart-content"><h6 class="widget-subheading">Produção</h6>
                      <div class="widget-chart-flex">
                        <div class="widget-numbers mb-0 w-100">
                          <div class="widget-chart-flex">
                            <div class="fsize-4 text-danger ml-auto mr-auto">
                              <small class="opacity-5"><i class="lnr-layers"></i></small>
                              26
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-4 col-xl-2">

                <div
                    class="card-shadow-primary border-info mb-3 widget-chart widget-chart2 text-left card btn-outline-2x">
                  <div class="widget-chat-wrapper-outer">
                    <div class="widget-chart-content"><h6 class="widget-subheading">Acabamento</h6>
                      <div class="widget-chart-flex">
                        <div class="widget-numbers mb-0 w-100">
                          <div class="widget-chart-flex">
                            <div class="fsize-4 ml-auto mr-auto">
                              <small class="opacity-5"><i class="lnr-text-format"></i></small>
                              05
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div class="col-4 col-xl-2">

                <div
                    class="card-shadow-primary  border-info mb-3 widget-chart widget-chart2 text-left card btn-outline-2x">
                  <div class="widget-chat-wrapper-outer">
                    <div class="widget-chart-content"><h6 class="widget-subheading">Expedição</h6>
                      <div class="widget-chart-flex">
                        <div class="widget-numbers mb-0 w-100">
                          <div class="widget-chart-flex">
                            <div class="fsize-4 ml-auto mr-auto">
                              <small class="opacity-5"><i class="lnr-exit"></i></small>
                              12
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>


            </div>


          </div>

          <div class="col-12">

            <div class="row">

              <div class="col-sm-12 col-md-5 col-lg-4">
                <div class="mb-3 card">

                  <div class="card-header-tab card-header">
                    <div class="card-header-title font-size-lg text-capitalize font-weight-normal">Capacidade
                      Matéria-Prima
                    </div>
                  </div>

                  <div class="card-body">

                    <apexchart type="radialBar" height="300" :options="chartOptions" :series="series"></apexchart>

                    <h6 class="text-muted text-uppercase font-size-md opacity-9 mb-2 font-weight-normal">Top
                      Crítico</h6>

                    <ul class="rm-list-borders rm-list-borders-scroll list-group list-group-flush">
                      <li class="list-group-item">
                        <div class="widget-content p-0">
                          <div class="widget-content-wrapper">
                            <div class="widget-content-left">
                              <div class="widget-heading">NBR 65 SH.A PT</div>
                              <div class="widget-subheading mt-1 opacity-10">
                                <div class="badge badge-pill badge-danger">5 DIAS</div>
                              </div>
                            </div>
                            <div class="widget-content-right">
                              <div class="fsize-1 text-focus">
                                <small class="opacity-5 pr-1">Estoque/Previsão</small>
                                <span>25kg/50kg</span>
                                <!--                                <small class="text-warning pl-2">
                                                                  <i class="fa fa-angle-down"></i>
                                                                </small>-->
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>

                      <li class="list-group-item">
                        <div class="widget-content p-0">
                          <div class="widget-content-wrapper">
                            <div class="widget-content-left">
                              <div class="widget-heading">VMQ 70 SH.A BR</div>
                              <div class="widget-subheading mt-1 opacity-10">
                                <div class="badge badge-pill badge-dark">15 DIAS</div>
                              </div>
                            </div>
                            <div class="widget-content-right">
                              <div class="fsize-1 text-focus">
                                <small class="opacity-5 pr-1">Estoque/Previsão</small>
                                <span>78kg/150kg</span>
                                <!--                                <small class="text-warning pl-2">
                                                                  <i class="fa fa-angle-down"></i>
                                                                </small>-->
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>


                    </ul>

                  </div>

                </div>
              </div>

              <div class="main-card col-lg-8 mb-3 card">
                <div class="card-header">
                  <div class="card-header-title font-size-lg font-weight-normal" style="text-transform: none">Fila de
                    Produção
                  </div>
                  <!--                  <div class="btn-actions-pane-right">
                                      <button type="button" class="btn-icon btn-wide btn btn-outline-focus btn-sm d-flex">
                                        Detalhar
                                        <span class="pl-2 align-middle opacity-7">
                                                          <i class="fa fa-angle-right"></i>
                                                      </span>
                                      </button>
                                    </div>-->
                </div>
                <div class="table-responsive">
                  <table class="align-middle text-truncate mb-0 table table-borderless table-hover">
                    <thead>
                    <tr>
                      <th class="text-center">Ordem Prod.</th>
                      <th class="text-center">Produto</th>
                      <th class="text-center">Qtd. Produzido/Total</th>
                      <th class="text-center">Etapa Atual</th>
                      <th class="text-center">Prazo</th>
                      <th class="text-center">Decorrido</th>
                      <th class="text-center">Status</th>
                    </tr>
                    </thead>
                    <tbody>


                    <tr v-for="order in orders" :key="order.numero_os">
                      <td class="text-center text-muted" style="width: 80px;">#{{ order.numero_os }}</td>
                      <td class="text-left">RET-123456 - 65,00 X 4,50</td>
                      <td class="text-center">
                        <a href="javascript:void(0)">{{ order.qtd_finalizada }}/{{ order.qtd_total }}</a>
                      </td>
                      <td class="text-center">
                        <span class="pr-2 opacity-6">
                            <i :class="order.etapa_atual_icone"></i>
                        </span>
                        {{ order.etapa_atual_descricao }}
                      </td>
                      <td class="text-center">{{ order.prazo }}</td>
                      <td class="text-center" style="width: 200px;">
                        <div class="widget-content p-0">
                          <div class="widget-content-outer">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left pr-2">
                                <div class="widget-numbers fsize-1">{{ order.percentual_finalizado }}%</div>
                              </div>
                              <div class="widget-content-right w-100">
                                <div class="progress-bar-xs progress">
                                  <div class="progress-bar bg-danger" role="progressbar"
                                       aria-valuemin="0" aria-valuemax="100"
                                       :style="{'width': order.percentual_finalizado+'%'}"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <div class="badge badge-pill" :class="order.status_cor">{{ order.status }}</div>
                      </td>
                    </tr>


                    </tbody>
                  </table>
                </div>

              </div>

            </div>

          </div>

        </b-tab>
        <b-tab title="Vendas" title-item-class="tabs_dashboard">

          <div class="row">
            <div class="col-md-6 col-xl-4">
              <div class="card mb-3 widget-content">
                <div class="widget-content-outer">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left">
                      <div class="widget-heading">Total Vendas Mês</div>
                      <div class="widget-subheading">Junho/2022</div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers"><small class="mr-1">R$</small>476 mil</div>
                    </div>
                  </div>
                  <div class="widget-progress-wrapper">
                    <div class="progress-bar-sm progress-bar-animated-alt progress">
                      <div class="progress-bar bg-success" role="progressbar" aria-valuenow="71" aria-valuemin="0"
                           aria-valuemax="100" style="width: 71%;"></div>
                    </div>
                    <div class="progress-sub-label">
                      <div class="sub-label-left">Meta R$ 595.000,00</div>
                      <div class="sub-label-right">80%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-4">
              <div class="card mb-3 widget-content">
                <div class="widget-content-outer">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left">
                      <div class="widget-heading">Total Vendas Semana</div>
                      <div class="widget-subheading">20/06 à 24/06</div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers"><small class="mr-1">R$</small>55 mil</div>
                    </div>
                  </div>
                  <div class="widget-progress-wrapper">
                    <div class="progress-bar-sm progress-bar-animated-alt progress">
                      <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="85" aria-valuemin="0"
                           aria-valuemax="100" style="width: 50%;"></div>
                    </div>
                    <div class="progress-sub-label">
                      <div class="sub-label-left">Meta R$ 110.000,00</div>
                      <div class="sub-label-right">50%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-xl-4">
              <div class="card mb-3 widget-content">
                <div class="widget-content-outer">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left">
                      <div class="widget-heading">Margem Bruta</div>
                      <div class="widget-subheading">Produtos vendidos de junho/2022</div>
                    </div>
                    <div class="widget-content-right">
                      <div class="widget-numbers text-danger">45,9%</div>
                    </div>
                  </div>
                  <div class="widget-progress-wrapper">
                    <div class="progress-bar-sm progress-bar-animated-alt progress">
                      <div class="progress-bar bg-danger" role="progressbar" aria-valuenow="46" aria-valuemin="0"
                           aria-valuemax="100" style="width: 45%;"></div>
                    </div>
                    <div class="progress-sub-label">
                      <div class="sub-label-left">Meta mínima 75%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>


          <b-row>

            <div class="col-md-6 col-xl-4">
              <div class="card mb-3 widget-content">
                <div class="widget-content-outer">


                  <div class="widget-content-left">
                    <div class="widget-heading">Ranking Cliente</div>
                    <div class="widget-subheading">Junho/2022</div>
                  </div>


                  <apexchart type="donut" :options="chartOptionsDonut" :series="seriesDonut"></apexchart>

                  <!--                  <h6 class="text-muted text-uppercase font-size-md opacity-9 mb-2 font-weight-normal">
                                      RANKING POR CLIENTE</h6>-->

                  <div class="table-responsive">
                    <table class="align-middle text-truncate mb-0 table table-borderless table-hover">
                      <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th class="text-center">Cliente</th>
                        <th class="text-center">%</th>
                        <th class="text-center">Valor Total</th>

                      </tr>
                      </thead>
                      <tbody>

                      32
                      25
                      23,8
                      9,9
                      8,7

                      <tr>
                        <td class="text-center text-muted" style="width: 80px;">2º</td>
                        <td class="text-left">Cliente Exemplo 1</td>
                        <td class="text-center">32,0%</td>
                        <td class="text-right">R$ 261.800,00</td>
                      </tr>

                      <tr>
                        <td class="text-center text-muted" style="width: 80px;">1º</td>
                        <td class="text-left">Cliente Exemplo 2</td>
                        <td class="text-center">25,0%</td>
                        <td class="text-right">R$ 209.440,00</td>
                      </tr>


                      <tr>
                        <td class="text-center text-muted" style="width: 80px;">3º</td>
                        <td class="text-left">Cliente Exemplo 3</td>
                        <td class="text-center">23,8%</td>
                        <td class="text-right">R$ 195.160,00</td>
                      </tr>

                      <tr>
                        <td class="text-center text-muted" style="width: 80px;">4º</td>
                        <td class="text-left">Cliente Exemplo 4</td>
                        <td class="text-center">9,9%</td>
                        <td class="text-right">R$ 80.920,00</td>
                      </tr>

                      <tr>
                        <td class="text-center text-muted" style="width: 80px;">5º</td>
                        <td class="text-left">Cliente Exemplo 5</td>
                        <td class="text-center">8,7%</td>
                        <td class="text-right">R$ 71.400,00</td>
                      </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-xl-4">

              <div class="card mb-3 widget-content">
                <div class="widget-content-outer">

                  <div class="widget-content-left">
                    <div class="widget-heading">Ranking Grupo Produto</div>
                    <div class="widget-subheading">Junho/2022</div>
                  </div>

                  <apexchart type="donut" :options="chartOptionsDonut" :series="seriesDonut"></apexchart>

                  <!--                  <h6 class="text-muted text-uppercase font-size-md opacity-9 mb-2 font-weight-normal">
                                      TOP 5 GRUPO PRODUTO</h6>-->

                  <div class="table-responsive">
                    <table class="align-middle text-truncate mb-0 table table-borderless table-hover">
                      <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th class="text-center">Cliente</th>
                        <th class="text-center">%</th>
                        <th class="text-center">Valor Total</th>

                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="text-center text-muted" style="width: 80px;">1º</td>
                        <td class="text-left">Exemplo Cliente</td>
                        <td class="text-center">25,60%</td>
                        <td class="text-right">R$ 650,00</td>
                      </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-xl-4">
              <div class="card mb-3 widget-content">
                <div class="widget-content-outer">

                  <div class="widget-content-left">
                    <div class="widget-heading">Ranking Vendedor</div>
                    <div class="widget-subheading">Junho/2022</div>
                  </div>

                  <apexchart type="donut" :options="chartOptionsDonut" :series="seriesDonut"></apexchart>


                  <div class="table-responsive">
                    <table class="align-middle text-truncate mb-0 table table-borderless table-hover">
                      <thead>
                      <tr>
                        <th class="text-center">#</th>
                        <th class="text-center">Cliente</th>
                        <th class="text-center">%</th>
                        <th class="text-center">Valor Total</th>

                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td class="text-center text-muted" style="width: 80px;">1º</td>
                        <td class="text-left">Exemplo Cliente</td>
                        <td class="text-center">25,60%</td>
                        <td class="text-right">R$ 650,00</td>
                      </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>


          </b-row>

        </b-tab>
        <b-tab title="Financeiro" title-item-class="tabs_dashboard">

          Teste

        </b-tab>
      </b-tabs>


    </div>


  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"

export default {
  mixins: [pageDefaultMixin],
  name: 'TypeTool',
  data() {
    return {
      path: "dashboard", //Utilizar somente quando fora do padrão

      /*
      ícones etapa atual
      lnr-hand
      lnr-leaf
      lnr-cog
      lnr-layers
      lnr-text-format
      lnr-exit*/
      orders: [
        {
          numero_os: "1001/2022",
          produto: "RETENTOR EXEMPLO",
          qtd_finalizada: "50",
          qtd_total: "100",
          etapa_atual_icone: "lnr-text-format",
          etapa_atual_descricao: "Acabamento",
          prazo: "22/06/2022",
          percentual_finalizado: "100",
          status: "Urgente",
          status_cor: "badge-danger",
        },
        {
          numero_os: "1002/2022",
          qtd_finalizada: "50",
          qtd_total: "100",
          etapa_atual_icone: "lnr-text-format",
          etapa_atual_descricao: "Acabamento",
          prazo: "22/06/2022",
          percentual_finalizado: "75",
          status: "Urgente",
          status_cor: "badge-danger",
        },
        {
          numero_os: "1003/2022",
          qtd_finalizada: "50",
          qtd_total: "100",
          etapa_atual_icone: "lnr-text-format",
          etapa_atual_descricao: "Acabamento",
          prazo: "22/06/2022",
          percentual_finalizado: "60",
          status: "Urgente",
          status_cor: "badge-danger",
        },
        {
          numero_os: "1004/2022",
          qtd_finalizada: "50",
          qtd_total: "100",
          etapa_atual_icone: "lnr-text-format",
          etapa_atual_descricao: "Acabamento",
          prazo: "22/06/2022",
          percentual_finalizado: "50",
          status: "Normal",
          status_cor: "badge-info",
        },
        {
          numero_os: "1005/2022",
          qtd_finalizada: "50",
          qtd_total: "100",
          etapa_atual_icone: "lnr-text-format",
          etapa_atual_descricao: "Acabamento",
          prazo: "22/06/2022",
          percentual_finalizado: "40",
          status: "Normal",
          status_cor: "badge-info",
        },
        {
          numero_os: "1006/2022",
          qtd_finalizada: "50",
          qtd_total: "100",
          etapa_atual_icone: "lnr-text-format",
          etapa_atual_descricao: "Acabamento",
          prazo: "22/06/2022",
          percentual_finalizado: "30",
          status: "Normal",
          status_cor: "badge-info",
        },
        {
          numero_os: "1007/2022",
          qtd_finalizada: "0",
          qtd_total: "100",
          etapa_atual_icone: "lnr-leaf",
          etapa_atual_descricao: "Matéria-Prima",
          prazo: "30/07/2022",
          percentual_finalizado: "20",
          status: "Normal",
          status_cor: "badge-info",
        },
        {
          numero_os: "1008/2022",
          qtd_finalizada: "0",
          qtd_total: "100",
          etapa_atual_icone: "lnr-leaf",
          etapa_atual_descricao: "Matéria-Prima",
          prazo: "30/07/2022",
          percentual_finalizado: "20",
          status: "Normal",
          status_cor: "badge-info",
        },
        {
          numero_os: "1009/2022",
          qtd_finalizada: "0",
          qtd_total: "100",
          etapa_atual_icone: "lnr-leaf",
          etapa_atual_descricao: "Matéria-Prima",
          prazo: "30/07/2022",
          percentual_finalizado: "20",
          status: "Normal",
          status_cor: "badge-info",
        },
        {
          numero_os: "1010/2022",
          qtd_finalizada: "0",
          qtd_total: "100",
          etapa_atual_icone: "lnr-leaf",
          etapa_atual_descricao: "Matéria-Prima",
          prazo: "30/07/2022",
          percentual_finalizado: "20",
          status: "Normal",
          status_cor: "badge-info",
        },

      ],

      seriesDonut: [261800, 209440, 195160, 80920, 71400],
      chartOptionsDonut: {
        chart: {
          type: 'donut',
        },
        labels: ['Cliente Exemplo 1', 'Cliente Exemplo 2', 'Cliente Exemplo 3', 'Cliente Exemplo 4', 'Cliente Exemplo 5'],
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },


      series: [75],
      chartOptions: {
        chart: {
          height: 350,
          type: 'radialBar',
          toolbar: {
            show: false
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 225,
            hollow: {
              margin: 0,
              size: '70%',
              background: '#fff',
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: 'front',
              dropShadow: {
                enabled: true,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24
              }
            },
            track: {
              background: '#dedede',
              strokeWidth: '100%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: -3,
                left: 0,
                blur: 4,
                opacity: 0.35
              }
            },
            dataLabels: {
              show: true,
              name: {
                offsetY: -10,
                show: true,
                color: '#888',
                fontSize: '17px'
              },
              value: {
                formatter: function (val) {
                  return parseInt(val) + '%';
                },
                color: '#111',
                fontSize: '36px',
                show: true,
              }
            }
          }
        },
        fill: {
          /*type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#ABE5A1'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }*/
        },
        stroke: {
          lineCap: 'round'
        },
        labels: ['Normal'],
      },


    }
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {


    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
}
</script>
<style>
.tabs_dashboard .active {
  background-color: #FFFFFF !important;
}

.tabs_dashboard .nav-link.active:hover {
  color: #3230d4 !important;
}
</style>
